import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgExport = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M22.68 19.018h-1.472a.212.212 0 0 0-.21.21v1.69H3.779V3.698h17.222v1.689c0 .115.095.21.21.21h1.471a.21.21 0 0 0 .21-.21v-2.74a.838.838 0 0 0-.839-.84H2.73a.838.838 0 0 0-.839.84v19.321c0 .465.375.84.84.84h19.32c.465 0 .84-.375.84-.84v-2.74a.21.21 0 0 0-.21-.21Zm.508-6.883-3.88-3.062a.22.22 0 0 0-.356.172v2.078h-8.585a.22.22 0 0 0-.22.22v1.53c0 .12.1.22.22.22h8.585v2.077a.22.22 0 0 0 .356.172l3.88-3.062a.219.219 0 0 0 0-.345Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgExport)
const Memo = memo(ForwardRef)
export default Memo
